module.exports = "/hwa/_next/static/images/binCollection-ec52adc39678e9e3d30bd15846764632.png";